import React, { useContext } from 'react';
import SubCategoryTable from './SubCategoryTable';
import { CommonContext } from '../../context/CommonContext';
import { SubCategoryContext } from '../../context/SubCategoryContext';
import { Box, Button, CardHeader, Paper } from '@mui/material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';

export default function SubCategoryScreenView() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal } = useContext(SubCategoryContext);
    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <AddModal />
            <Box className="component-header">
                <CardHeader title="Sub Category" />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" onClick={handleAddModal}>
                        Add Sub Category
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <SubCategoryTable />
            </Paper>
        </div>
    );
}
